// src/components/reportReviewModal/ReportReviewModal.jsx
import React, { useState, useContext, useEffect } from "react";
import "./reportReviewModal.css";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import usersRequest from "../../request/usersRequest";

const ReportReviewModalCustomer = ({ open, onClose, reviewId, shopId }) => {
	const { language, userData } = useContext(CombinedContext);

	const [reason, setReason] = useState("");
	const [details, setDetails] = useState("");
	const [emailInput, setEmailInput] = useState("");
	const [loading, setLoading] = useState(false);
	const [toast, setToast] = useState("");

	const isLoggedIn = Boolean(userData?.user?.email);

	// Lock scroll when modal is open
	useEffect(() => {
		document.body.style.overflow = open ? "hidden" : "";
		return () => {
			document.body.style.overflow = "";
		};
	}, [open]);

	if (!open) return null;

	const reasons = [
		{ id: "spam", label: translations[language].reportReview.reason.spam },
		{ id: "inappropriate", label: translations[language].reportReview.reason.inappropriate },
		{ id: "harassment", label: translations[language].reportReview.reason.harassment },
		{ id: "incorrect", label: translations[language].reportReview.reason.incorrect },
		{ id: "other", label: translations[language].reportReview.reason.other },
	];

	async function submitReport() {
		if (!reason) {
			setToast(translations[language].reportReview.actions.selectReasonError);
			return;
		}

		try {
			setLoading(true);

			const emailToSend = userData?.user?.email || emailInput || null;

			await usersRequest.flagReview(shopId, reviewId, {
				reason,
				message: details,
				email: emailToSend,
			});
			
			setToast(translations[language].reportReview.actions.success);

			setTimeout(() => {
				onClose();
			}, 900);
		} catch (err) {
			console.error("Failed to report review:", err);
			setToast(translations[language].reportReview.actions.error);
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="sf-report-overlay" onClick={onClose}>
			<div className="sf-report-modal" onClick={(e) => e.stopPropagation()}>
				{/* HEADER */}
				<div className="sf-report-header">
					<h3 className="sf-report-title">
						{translations[language].reportReview.title}
					</h3>

					<button className="sf-report-close" onClick={onClose}>
						✕
					</button>
				</div>

				{/* BODY */}
				<div className="sf-report-body">
					<p className="sf-report-subtitle">
						{translations[language].reportReview.subtitle}
					</p>

					{/* REASON SELECT */}
					<select
						className="sf-report-select"
						value={reason}
						onChange={(e) => setReason(e.target.value)}
					>
						<option value="">
							{translations[language].reportReview.actions.selectReason}
						</option>
						{reasons.map((r) => (
							<option key={r.id} value={r.id}>
								{r.label}
							</option>
						))}
					</select>

					{/* DETAILS */}
					<textarea
						className="sf-report-textarea"
						placeholder={translations[language].reportReview.placeholder}
						value={details}
						onChange={(e) => setDetails(e.target.value)}
					/>

					{/* EMAIL (only if not logged in) */}
					{!isLoggedIn && (
						<input
							type="email"
							className="sf-report-email-input"
							placeholder={
								language === "es"
									? "Tu email (opcional)"
									: "Your email (optional)"
							}
							value={emailInput}
							onChange={(e) => setEmailInput(e.target.value)}
						/>
					)}
				</div>

				{/* FOOTER */}
				<div className="sf-report-footer">
					<button className="sf-report-btn-cancel" onClick={onClose}>
						{translations[language].reportReview.actions.cancel}
					</button>

					<button
						className="sf-report-btn-submit"
						onClick={submitReport}
						disabled={loading}
					>
						{loading
							? language === "es"
								? "Enviando..."
								: "Submitting..."
							: translations[language].reportReview.actions.submit}
					</button>
				</div>

				{toast && <div className="sf-report-toast">{toast}</div>}
			</div>
		</div>
	);
};

export default ReportReviewModalCustomer;
